import moment from "moment"
import { get } from "lodash"
import { Alert } from "@mui/material"
import { DATE_FORMAT } from "helpers/dates"

export function getInitialExpirationDate(token) {
  if (!get(token, "expiresOn")) {
    return null
  }
  return isExpired(token) ? null : moment(token.expiresOn).format(DATE_FORMAT)
}

export function getEarliestExpirationDate() {
  return moment().add(1, "days").format(DATE_FORMAT)
}

export function isExpired(token) {
  if (!get(token, "expiresOn")) {
    return false
  }
  const expiresOn = moment(token.expiresOn)
  return expiresOn.isBefore()
}

export function getExpirationWarning(token) {
  return isExpired(token) ? <Alert className="token-expiration-warning" severity="warning">Token has expired. Please set a new expiration date (optional).</Alert> : null
}

export function formatTokenExpirationDate(value) {
  return value ? moment(value).format("ll") : "Never"
}
